"use client";

import dynamic from "next/dynamic";

const Placeholder = ({ h = "h-[300px]" }: { h?: string }) => (
  <div className={`${h} bg-neutral-50 animate-pulse rounded-lg`} />
);

export const AskPelicanSectionLazy = dynamic(
  () => import("./AskPelicanSection"),
  { ssr: false, loading: () => <Placeholder h="h-[350px]" /> },
);

export const HurricaneCenterLazy = dynamic(
  () => import("./HurricaneCenter"),
  { ssr: false, loading: () => <Placeholder /> },
);

export const AboutSectionLazy = dynamic(
  () => import("./AboutSection"),
  { ssr: false, loading: () => <Placeholder /> },
);

export const AccessSectionLazy = dynamic(
  () => import("./AccessSection"),
  { ssr: false, loading: () => <Placeholder /> },
);
